export function getAxisPosition([domainMin, domainMax]: number[]): number {
  return Math.min(Math.max(0, domainMin), domainMax);
}
